import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDetails } from "../../../../store/Slices/userSlice.js";
import { CheckKycStatusApi } from '../../../../api/request/kyc';
import { useNavigate } from 'react-router-dom';

const KycRequested = ({ setPending }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userDetails } = useSelector(state => state.user);

  const checkKycStatus = async () => {
    try {
      let params = {
        UserId: userDetails?._id
      }
      const { data } = await CheckKycStatusApi(new URLSearchParams(params).toString());
      if (data?.success) {
        dispatch(setUserDetails({ ...userDetails, kycStatus: data?.data?.kycStatus }));
        if (data?.data?.kycStatus === 'Pending') {
          setPending(true);
        }
        if (data?.data?.kycStatus === 'Rejected') {
          setPending(false);
        }
        if (data?.data?.kycStatus === 'Approved') {
          navigate('/dashboard');
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      }
    } catch (error) { }
  }

  useEffect(() => {
    checkKycStatus();
  }, []);

  return (
    <div>
      <div className='container grid md:grid-cols-2 grid-cols-1 justify-items-center items-center p-5 mx-auto mt-5'>
        <div className='grid grid-cols-1 gap-8'>
          <div>
            <p className='font-bold text-[#2F2B3D] sm:text-4xl text-xl'>Your KYC is under proccess...</p>
            <p className="mt-4">Please wait your kyc request has been pending.</p>
          </div>
        </div>
        <div>
          <img src="/assets/images/kyc.png" alt="" className='w-[35rem] p-4' />
        </div>
      </div>
    </div>
  )
}

export default KycRequested